<template>
  <div class="floating-bar">
    <!-- 微信 -->
    <div class="float-item wechat-item" @mouseenter="showWechat = true" @mouseleave="showWechat = false">
      <button class="float-btn" title="微信咨询">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.858C16.205 4.422 12.692 2.188 8.691 2.188zm-1.79 3.155a1.024 1.024 0 110 2.048 1.024 1.024 0 010-2.048zm4.893 0a1.024 1.024 0 110 2.048 1.024 1.024 0 010-2.048zM24 14.135c0-3.417-3.284-6.188-7.332-6.188-4.048 0-7.332 2.77-7.332 6.188 0 3.418 3.284 6.188 7.332 6.188.849 0 1.666-.113 2.435-.317a.72.72 0 01.583.082l1.546.906a.268.268 0 00.135.044.24.24 0 00.236-.24c0-.058-.024-.115-.04-.174l-.317-1.202a.481.481 0 01.173-.54C23.078 17.894 24 16.115 24 14.135zm-9.869-.762a.833.833 0 110-1.666.833.833 0 010 1.666zm5.075 0a.833.833 0 110-1.666.833.833 0 010 1.666z"/>
        </svg>
      </button>
      <!-- WeChat popup -->
      <transition name="popup-slide">
        <div v-if="showWechat" class="float-popup wechat-popup">
          <div class="popup-header">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#07C160"><path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.858C16.205 4.422 12.692 2.188 8.691 2.188z"/></svg>
            微信扫码咨询
          </div>
          <div class="qrcode-placeholder">
            <div class="qr-mock">
              <div class="qr-grid">
                <div v-for="n in 49" :key="n" class="qr-cell" :class="{ filled: qrPattern[n-1] }"></div>
              </div>
            </div>
            <p class="qr-tip">扫码添加微信顾问</p>
          </div>
        </div>
      </transition>
    </div>

    <!-- 电话 -->
    <div class="float-item" @mouseenter="showPhone = true" @mouseleave="showPhone = false">
      <button class="float-btn phone-btn" title="电话联系">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
          <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 01.03 2.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.08 6.08l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
        </svg>
      </button>
      <transition name="popup-slide">
        <div v-if="showPhone" class="float-popup phone-popup">
          <div class="popup-header">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--primary)" stroke-width="2.5"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 01.03 2.18 2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.08 6.08l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
            电话咨询
          </div>
          <div class="phone-number">400-9027-208</div>
          <div class="phone-time">周一至周日 9:00 - 21:00</div>
        </div>
      </transition>
    </div>

    <!-- 客服 -->
    <div class="float-item" @mouseenter="showService = true" @mouseleave="showService = false">
      <button class="float-btn service-btn" title="在线客服">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round">
          <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
          <circle cx="9" cy="10" r="1" fill="currentColor"/>
          <circle cx="12" cy="10" r="1" fill="currentColor"/>
          <circle cx="15" cy="10" r="1" fill="currentColor"/>
        </svg>
      </button>
      <transition name="popup-slide">
        <div v-if="showService" class="float-popup service-popup">
          <div class="popup-header">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7C3AED" stroke-width="2.5"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
            在线客服
          </div>
          <div class="service-status">
            <span class="status-dot"></span>
            客服在线中，响应时间 &lt; 1分钟
          </div>
          <a href="#" class="service-cta">
            立即对话
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </a>
        </div>
      </transition>
    </div>

    <!-- 分割线 -->
    <div class="float-divider"></div>

    <!-- 回到顶端 -->
    <transition name="fade-up">
      <button
        v-if="showTop"
        class="float-btn top-btn"
        title="回到顶端"
        @click="scrollToTop"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
          <path d="M18 15l-6-6-6 6"/>
          <line x1="12" y1="21" x2="12" y2="9" opacity="0.4"/>
        </svg>
      </button>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FloatingBar',
  data() {
    return {
      showWechat: false,
      showPhone: false,
      showService: false,
      showTop: false,
      /* QR code mock pattern — 7×7 grid of filled/empty cells */
      qrPattern: [
        1,1,1,1,1,1,1,
        1,0,0,0,0,0,1,
        1,0,1,0,1,0,1,
        1,0,0,1,0,0,1,
        1,0,1,0,1,0,1,
        1,0,0,0,0,0,1,
        1,1,1,1,1,1,1,
        0,0,1,0,1,0,0,
        1,1,0,1,0,1,1,
        0,1,0,0,0,1,0,
        1,0,1,1,1,0,1,
        0,1,0,0,0,1,0,
        1,0,1,0,1,0,1,
        0,0,1,1,1,0,0,
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll() {
      this.showTop = window.scrollY > 400
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.floating-bar {
  position: fixed;
  right: 20px;
  bottom: 80px;
  z-index: 900;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

/* ── Shared button ── */
.float-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 1.5px solid var(--border);
  background: var(--bg-card);
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;
  box-shadow: var(--shadow);
  position: relative;
}
.float-btn:hover {
  transform: scale(1.1);
  box-shadow: var(--shadow-lg);
}

/* Color variants */
.float-item:nth-child(1) .float-btn:hover { background: #07C160; border-color: #07C160; color: white; }
.phone-btn:hover    { background: var(--primary); border-color: var(--primary); color: white; }
.service-btn:hover  { background: #7C3AED; border-color: #7C3AED; color: white; }
.top-btn {
  background: var(--gradient-brand);
  border-color: transparent;
  color: white;
}
.top-btn:hover { opacity: 0.9; }

/* ── Popup card ── */
.float-item { position: relative; }
.float-popup {
  position: absolute;
  right: 58px;
  bottom: 0;
  width: 210px;
  background: var(--bg-card);
  border: 1.5px solid var(--border);
  border-radius: 16px;
  padding: 16px;
  box-shadow: var(--shadow-lg);
  pointer-events: auto;
}

.popup-header {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--border-light);
}

/* WeChat QR */
.qrcode-placeholder { text-align: center; }
.qr-mock {
  width: 110px;
  height: 110px;
  margin: 0 auto 8px;
  padding: 8px;
  background: white;
  border-radius: 10px;
  border: 1px solid var(--border);
}
.qr-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1.5px;
  width: 100%;
  height: 100%;
}
.qr-cell {
  border-radius: 1px;
  background: transparent;
}
.qr-cell.filled { background: #1a1a1a; }
.qr-tip {
  font-size: 0.72rem;
  color: var(--text-muted);
}

/* Phone */
.phone-number {
  font-size: 1.1rem;
  font-weight: 800;
  color: var(--primary);
  letter-spacing: 0.04em;
  margin-bottom: 6px;
}
.phone-time {
  font-size: 0.72rem;
  color: var(--text-muted);
}

/* Service */
.service-status {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin-bottom: 12px;
  line-height: 1.5;
}
.status-dot {
  width: 8px; height: 8px;
  border-radius: 50%;
  background: #10B981;
  box-shadow: 0 0 0 3px rgba(16,185,129,0.25);
  flex-shrink: 0;
  animation: pulse-ring 1.5s ease-out infinite;
}
.service-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 9px;
  background: linear-gradient(135deg, #7C3AED, #A855F7);
  color: white;
  border-radius: 100px;
  font-size: 0.82rem;
  font-weight: 700;
  text-decoration: none;
  transition: opacity 0.2s;
}
.service-cta:hover { opacity: 0.88; }

/* Divider */
.float-divider {
  width: 28px;
  height: 1px;
  background: var(--border);
  margin: 2px 0;
}

/* Popup transition */
.popup-slide-enter-active, .popup-slide-leave-active {
  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
}
.popup-slide-enter, .popup-slide-leave-to {
  opacity: 0;
  transform: translateX(8px) scale(0.96);
}

/* Back to top transition */
.fade-up-enter-active, .fade-up-leave-active { transition: all 0.3s ease; }
.fade-up-enter, .fade-up-leave-to { opacity: 0; transform: translateY(12px); }

@media (max-width: 768px) {
  .floating-bar { right: 12px; bottom: 60px; }
  .float-btn { width: 42px; height: 42px; }
  .float-popup { width: 185px; right: 52px; }
}
</style>
